
const domain = process.env.NODE_ENV === "development" ? "http://localhost:4003" : "https://www.global-medica.net";


export const urls = {
  authRoute: `${domain}/api/v1/auth-customers-external`,
  signUp: `${domain}/api/v1/auth-customers-external/sign-up-customers`,
  validEmail: `${domain}/api/v1/auth-customers-external/email-validation`,
  serviceCallList: `${domain}/api/v1/service-calls-for-customers`,
  serviceEquipments: `${domain}/api/v1/equipments-for-customers`,
  contactCustomer: `${domain}/api/v1/contact-customer`,
  listCalls: `${domain}/api/v1/equipments-for-customers/service/calls`
};